import EnergyPriceSetupModal from 'src/components/Consumption/VerivoxEnergyPriceIntegration/modals/setup/EnergyPriceSetupModal.svelte';
import type { ModalConfig } from 'src/types/Modals';
import { energyPriceApi } from 'src/components/Consumption/VerivoxEnergyPriceIntegration/api/verivoxApi';
import { isEnergyPriceFeatureEnabled } from 'src/helpers/energy_price_helpers';

export const EnergyPriceSetupModalConfig = (): ModalConfig => ({
	id: 'energyPriceSetup',
	component: EnergyPriceSetupModal,
	props: {
		showModal: true,
	},
	rules: [
		{
			check: () => {
				return energyPriceApi.getCachedLocation() === null;
			},
			expected: true,
		},
		{
			check: () => {
				return isEnergyPriceFeatureEnabled();
			},
			expected: true,
		},
	],
});
